<template>
  <div class="content-wrapper" v-if="isPaymentError == false">
    <div class="buyticket">
      <!-- バウチャーの場合ヘッダーはいらない -->
      <TheStoreHeader v-if="!isVoucher" page="3" :is0yenTicket="is0yenTicket" />
      <div
        v-else
        style="margin-top: calc(30px + env(safe-area-inset-top, 30px) + 30px)"
      />
      <!-- バウチャーの場合ヘッダーはいらない -->

      <div class="form">
        <MbNameDisp :name="displayBookName(bookGroup, masterBook)" />

        <p v-if="isVoucher">チケットの入手が完了いたしました。</p>
        <p v-else-if="is0yenTicket">チケットの取得が完了いたしました。</p>
        <p v-else>
          {{ $t("TicketStoreTicketing.BookBookingResult.title") }}
        </p>
        <br />
        <p v-if="is0yenTicket">
          取得いただいたチケットはホーム画面の「使う」からご確認、ご利用いただけます。
        </p>
        <p v-else>
          {{ $t("TicketStoreTicketing.BookBookingResult.description") }}
        </p>

        <TheBBRActions style="margin-top: 20px" />
      </div>
    </div>
  </div>
  <div v-else class="content-wrapper safe-top">
    <div class="form form-middle">
      <div class="form-content-middle">
        <div class="img-container">
          <img src="@/assets/img/dialog/svg/dialog_alert.svg" alt="" />
        </div>
        <!-- success + mail_sent fail  -->
        <div
          v-if="
            paymentProcessInfo.result == 'success' &&
            paymentProcessInfo.mail_sent == false
          "
        >
          <div class="msg">
            <p>
              購入は完了しましたが、メールの送信時にエラーが生じました。購入内容のご確認や、領収書・明細書をご希望の場合は、EMotサポートセンターにお問い合わせください。
            </p>
          </div>
          <div class="foot-button-block">
            <div class="actions">
              <ItemButton
                label="お問い合わせページへ"
                actionType="btn-primary"
                @clicked="gotoInquiryPage()"
              />
            </div>
          </div>
        </div>
        <!-- payable_error error -->
        <div
          v-else-if="
            paymentProcessInfo.result == 'error' &&
            (paymentProcessInfo.error == 'payable_error' || paymentProcessInfo.error == 'sales_error_reservation_expired' )
          "
        >
          <div class="msg">
            <p>
              仮予約から所定の時間が経過したため、仮予約が取り消されました。もう一度お試しください。
            </p>
          </div>
          <div class="foot-button-block">
            <div class="actions">
              <ItemButton
                label="OK"
                actionType="btn-primary"
                @clicked="gotoTopPage()"
              />
            </div>
          </div>
        </div>
        <!-- general error -->
        <div
          v-else-if="
            paymentProcessInfo.result == 'error'
          "
        >
          <div class="msg">
            <div>決済に失敗しました。</div>
            <div>大変お手数ですがもう一度購入手続きをやり直してください。</div>
          </div>
          <div class="foot-button-block">
            <div class="actions">
              <ItemButton
                label="OK"
                actionType="btn-primary"
                @clicked="gotoConfirmationPage()"
              />
            </div>
          </div>
        </div>
        <!-- return_url timeout -->
        <div
          v-else-if="
            paymentProcessInfo.result == 'timeout' &&
            paymentLaunchUrl.includes('result=success')
          "
        >
          <div class="msg">
            <p>
              処理結果が取得できませんでした。しばらく経っても選択したチケットが一覧に表示されない場合は、大変お手数ですがもう一度購入手続きをやり直してください。
            </p>
          </div>
          <div class="foot-button-block">
            <div class="actions">
              <ItemButton
                label="チケットを確認する"
                actionType="btn-primary"
                @clicked="gotoMyTiketPage()"
              />
            </div>
          </div>
        </div>
        <!-- error_url timeout -->
        <div
          v-else-if="
            paymentProcessInfo.result == 'timeout' &&
            paymentLaunchUrl.includes('result=error')
          "
        >
          <div class="msg">
            <p>
              決済に失敗した可能性があります。選択したチケットが一覧に表示されない場合は、大変お手数ですがもう一度購入手続きをやり直してください。
            </p>
          </div>
          <div class="foot-button-block">
            <div class="actions">
              <ItemButton
                label="チケットを確認する"
                actionType="btn-primary"
                @clicked="gotoMyTiketPage()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateBookBookingResult",
  props: {
    isPaymentError: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    console.log("props.isPaymentError", props.isPaymentError);
    console.log("masterBook::", masterBook.value);
    console.log("bookGroup::", masterBook.value);

    //payment info
    const paymentProcessInfo = computed(
      () => store.getters["ticketing/paymentProcessInfo"]
    );
    const paymentLaunchUrl = computed(
      () => store.getters["ticketing/paymentLaunchUrl"]
    );

    const isVoucher = route.query.voucher == "true";
    const is0yenTicket = route.query.is_0yen_ticket == "true" ? true : false;

    const gotoInquiryPage = () => {
      nativeHandlerService.ncReturnNativeAppToContactUs();
    };
    const gotoConfirmationPage = () => {
      router.go(-2);

      // router.push({
      //   name: "BookBookingConfirmation",
      //   params: {
      //     id: route.params.id,
      //     book_group_id: store.getters["ticketing/bookGroup"].id,
      //   },
      //   query: {
      //     language: store.getters["common/lang"],
      //     is_0yen_ticket: route.query.is_0yen_ticket,
      //     master_book_set_id: route.query.master_book_set_id,
      //   },
      // });
    };
    const gotoTopPage = () => {
      nativeHandlerService.returnNativeAppTopPage();
    };
    const gotoMyTiketPage = () => {
      nativeHandlerService.returnNativeAppMyticketPage();
    };

    return {
      isVoucher,
      bookGroup,
      masterBook,
      is0yenTicket,
      paymentProcessInfo,
      paymentLaunchUrl,
      gotoInquiryPage,
      gotoConfirmationPage,
      gotoTopPage,
      gotoMyTiketPage
    };
  },
};
</script>
<style lang="scss" scoped>
.buyticket .form {
  margin: 20px 15px;
}

p {
  margin: 20px 0;
  line-height: 15px;
  font-size: 15px;
}
.safe-top {
  margin-top: calc(30px + env(safe-area-inset-top, 30px) + 30px);
}
.msg {
  padding: 0 20px;
  font-size: 15px;
  text-align: left;
}
.img-container {
  text-align: center;
}

.img-container img {
  height: 90px;
  width: 90px;
}

.form-middle {
  position: absolute;
  width: 100%;
  height: 50%;
}

.form-content-middle {
  position: absolute;
  width: 100%;
  bottom: 45px;
}

.foot-button-block {
  position: fixed;
  z-index: 99;
  width: 100%;
  bottom: 0;
  background-color: #fff;
}

.foot-button-block .actions {
  width: 90%;
  margin: auto;
}
</style>
